import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import { GET_LAYOUT_MAX_WIDTH } from '../../../constants/layout';

export const getBannerSize = () => {
  const maxWith = 300;
  const homePagePadding = 15;
  const contentWidth = GET_LAYOUT_MAX_WIDTH() - homePagePadding * 2;
  const bannerWidth = Math.min(Math.floor(contentWidth / 2), maxWith);

  return {
    width: bannerWidth,
    height: bannerWidth * (270 / 167),
  };
};

export const styles = StyleSheet.create({
  pagination: {
    top: 8,
    left: 12,
    justifyContent: 'flex-start',
  },
});

export default {
  Section: styled.View`
    padding: 0px 15px;
    width: 100%;
    flex: 1;
    flex-direction: row;
  `,
  FlexBlock: styled.View`
    flex: 1;
  `,
  BannerBlock: styled.View<{ width: number }>`
    width: ${({ width }) => width}px;
    overflow: hidden;
  `,
};
